import * as React from "react";
import Parse from "html-react-parser";
import { HTMLReactParserOptions } from "html-react-parser";

export const HTMLtoJSX = (html: string, options?: HTMLReactParserOptions) => {
  return typeof html === "string" ? Parse(html, options) : html;
};
